import { getProjectsNav } from "./projects";
import { getPackageNav, getReducedPackageNav } from "./package";
import { NavItemType } from "types";
import { getAnalysisNav } from "./analysis";
import { getReportingNav } from "./reporting";
import { getDirectoryNav } from "./directory";

export const getNavMenuItems = (
  projectId: string,
  isOwner: boolean
): { items: NavItemType[] } => {
  const items = [getProjectsNav()];

  if (isOwner) {
    items.push(getPackageNav(projectId));
  } else {
    items.push(getReducedPackageNav(projectId));
  }

  if (isOwner) {
    items.push(getReportingNav(projectId));
  }
  items.push(getAnalysisNav(projectId));
  items.push(getDirectoryNav(projectId));

  return { items };
};
